import { COMMENT_BOX, DROPDOWN, SINGLE_CHOICE, SINGLE_TEXTBOX, SLIDER, STAR_RATING } from '../questionTypes';

export const mapAnswersFromAPI = (apiQuestion = {}) => {
  if (apiQuestion.family === 'single_choice' || apiQuestion.family === 'multiple_choice') {
    const answers = [];
    apiQuestion.answers.choices.forEach(choice => {
      const answer = { answer: choice.text, score: '' };
      if (choice.quiz_options) {
        answer.score = choice.quiz_options.score.toString();
      }
      answers.push(answer);
    });

    return answers;
  }

  return [];
};

export const mapQuestionTypeFromAPI = (family, subtype, displayOptions = {}) => {
  const singleChoiceSubType = subtype === 'vertical' || subtype === 'vertical_two_col' ? SINGLE_CHOICE : DROPDOWN;
  switch (family) {
    case 'single_choice':
      return singleChoiceSubType;
    case 'multiple_choice':
      return 'multiple_choice';
    case 'open_ended':
      if (subtype === 'single') {
        if (displayOptions.display_type === 'slider') {
          return SLIDER;
        }
        return SINGLE_TEXTBOX;
      }
      if (subtype === 'essay') {
        return COMMENT_BOX;
      }
      break;
    case 'matrix':
      if (
        subtype === 'rating' &&
        displayOptions.display_type === 'emoji' &&
        displayOptions.display_subtype === 'star'
      ) {
        return STAR_RATING;
      }
      break;
    default:
      return singleChoiceSubType;
  }

  return null;
};

export const mapQuestionFromApi = (question, surveyDetails) => {
  return {
    id: question.id || question.question_id,
    question: question.headings[0].heading,
    questionType: mapQuestionTypeFromAPI(question.family, question.subtype, question.display_options),
    answers: mapAnswersFromAPI(question),
    min: question.validation ? question.validation.min : 0,
    max: question.validation ? question.validation.max : 100,
    allowComments: false,
    required: !!question.required,
    isNew: surveyDetails && surveyDetails.id === undefined,
    isUpdated: false,
    initialPosition: question.position,
  };
};
